import { getDeviceId } from '../deviceId'
import { getSessionId, touchSession } from './session'
import { Config } from './constants'
import { redactGiftLinks } from './giftLinkPrivacy'

let queue = []
let timer = null
let eventCountThisMinute = 0
let minuteResetTimer = null

function startMinuteReset() {
  if (minuteResetTimer) return
  minuteResetTimer = setInterval(() => { eventCountThisMinute = 0 }, 60000)
}

function startFlushTimer() {
  if (timer) return
  timer = setTimeout(() => {
    timer = null
    flush()
  }, Config.FLUSH_INTERVAL)
}

function stopFlushTimer() {
  if (timer) {
    clearTimeout(timer)
    timer = null
  }
}

export function enqueue(event) {
  try {
    startMinuteReset()
    if (eventCountThisMinute >= Config.MAX_EVENTS_PER_MINUTE) return
    eventCountThisMinute++

    touchSession()
    queue.push({
      ...redactGiftLinks(event),
      clientTimestamp: Date.now(),
    })

    if (queue.length >= Config.BATCH_SIZE) {
      flush()
    } else {
      startFlushTimer()
    }
  } catch (e) { /* 静默 */ }
}

export function flush() {
  try {
    stopFlushTimer()
    if (!queue.length) return
    const batch = queue.splice(0, 50)
    send(batch)
  } catch (e) { /* 静默 */ }
}

function getUserId() {
  try {
    const userStr = localStorage.getItem('user')
    if (userStr) {
      const user = JSON.parse(userStr)
      return user.id || null
    }
  } catch { /* 静默 */ }
  return null
}

function send(events) {
  try {
    const payload = JSON.stringify({
      deviceId: getDeviceId(),
      sessionId: getSessionId(),
      userId: getUserId(),
      events,
    })

    const token = localStorage.getItem('token')
    const headers = { 'Content-Type': 'application/json' }
    if (token) headers['Authorization'] = `Bearer ${token}`

    if (document.visibilityState === 'hidden' && navigator.sendBeacon) {
      const blob = new Blob([payload], { type: 'application/json' })
      navigator.sendBeacon(Config.TRACK_ENDPOINT, blob)
    } else {
      fetch(Config.TRACK_ENDPOINT, {
        method: 'POST',
        headers,
        body: payload,
        keepalive: true,
      }).catch(() => {})
    }
  } catch (e) { /* 静默 */ }
}

export function setupUnloadFlush() {
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'hidden') flush()
  })
  window.addEventListener('beforeunload', () => flush())
}
